export default "__VITE_ASSET__Bb1qBggP__"